import { allFieldsFinalPrice, allFieldsUsedAmount, allFieldsUseDeposit } from 'bl/fields.bl';
import asArray from 'utils/arrays/asArray.util';
import alwaysSame from 'utils/functions/nullary/alwaysSame.util';
import parsfixed from 'utils/values/parsfixed.util';

const plus = (a, b) => a + b;

const asArrayFiltered = (value) => asArray(value).filter(alwaysSame);

const addClientPrices = (total, { services, products }) => total + [...allFieldsFinalPrice(services), ...allFieldsFinalPrice(products)].filter(alwaysSame).reduce(plus, 0);

const validateCheckoutData = (data) => {
  const { additionalDiscount, cardAmount, clients, onlineAmount, otherAmount, partCash, tipAmount, depositListData: deposits, vouchers_used: vouchers, charges } = data ?? {};

  const totalFromClients = Number.parseFloat(tipAmount) + asArray(clients).filter(alwaysSame).reduce(addClientPrices, 0);

  const deposit = asArrayFiltered(allFieldsUseDeposit(deposits)).reduce(plus, 0);
  const voucher = asArrayFiltered(allFieldsUsedAmount(vouchers)).reduce(plus, 0);

  const totalFromMethods = onlineAmount + partCash + otherAmount + cardAmount - additionalDiscount + deposit + voucher;

  const totalFees = charges?.fees?.reduce((acc, fee) => acc + fee.fee_amount, 0);
  const totalTaxes = charges?.taxes?.reduce((acc, tax) => acc + tax.total_tax_amount, 0);
  const totalTaxesAndFees = totalFees + totalTaxes;

  // Subtotal = sum of service prices + service discounts + product prices + product discounts
  // vs
  // Total Amount Paid = sum of payment methods, i.e. cash + card + card via Slick + voucher + deposit used
  const totalFromClientsParsed = parsfixed(totalFromClients + totalTaxesAndFees);
  const totalFromMethodsParsed = parsfixed(totalFromMethods);

  const isValid = totalFromClientsParsed === totalFromMethodsParsed;

  return {
    isValid,

    totals: {
      clients: totalFromClients,
      methods: totalFromMethods,
      clientsParsed: totalFromClientsParsed,
      methodsParsed: totalFromMethodsParsed,
    },

    inputs: {
      additionalDiscount,
      cardAmount,
      deposits,
      onlineAmount,
      otherAmount,
      partCash,
      tipAmount,
      vouchers,
      deposit,
      voucher,
      charges,
    },
  };
};

export default validateCheckoutData;
